/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Offcanvas from "react-bootstrap/Offcanvas";
import Row from "react-bootstrap/Row";
import { MdDelete, MdKeyboardArrowRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import safetyImg from "../../assets/safety-image.jpg";
import { useAuth } from "../../contexts/AuthContext";
import { getSocket } from "../../Services/Socket";
import PhonePay from "../Payment/Phonepe";
import "./index.css";
import axios from "axios";
import { FiTag } from "react-icons/fi";
import { FaLongArrowAltDown } from "react-icons/fa";
import { BiChevronsDown } from "react-icons/bi";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import platform from "platform";

const Cart = () => {
  // const [searchParams, setSearchParams] = useSearchParams();
  const OS = platform.os?.family;

  const {
    cartProducts,
    handleSetCartProducts,
    totalPrice,
    totalDiscount,
    totalMRP,
    selectedProduct,
    handleSelectProduct,
    setSelectedProduct,
    setStep,
    themColor,
    totalExtraDiscount,
    handleCloseCart,
    address,
    showOffset,
    setCartProducts,
  } = useAuth();
  const isAddressAvailable =
    address?.fullname && address?.mobile && address?.city;

  const isCartNotEmpty = cartProducts?.length > 0;
  const [showOffCanvas, setShowOffCanvas] = useState({
    show: false,
    size: false,
    product: {},
    ctx: null, // { type: 'cart' | 'freebie', id?: string }
  });
  const [freebieSelections, setFreebieSelections] = useState({});
  const sizeSectionRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (cartProducts?.length > 0) {
      setSelectedProduct(cartProducts);
    }
  }, [cartProducts]);

  // const handlePaymentSuccess = () => {
  //   setLoading(true);

  //   const domainname = window.location.hostname;

  //   const paymentAlias = {
  //     paytm: "pt",
  //     cashfree: "cs",
  //     phonepe: "pe",
  //     indianpay: "ip",
  //     razorpay: "rp",
  //     payu: "pu",
  //     pinelab: "pl",
  //   }[String(process.env.REACT_APP_PAYMENT_TYPE || "").toLowerCase()];

  //   const successUrl = `${process.env.REACT_APP_GETWAY_URL}/multipayment?amount=${totalPrice}&name=${encodeURIComponent(address.fullname)}&mobileno=${encodeURIComponent(address.mobile)}&domainname=${encodeURIComponent(domainname)}&pa=${paymentAlias || ""}`;

  //   localStorage.setItem("isLoading", true);
  //   window.location.href = successUrl;
  // };

  if (localStorage.getItem("isLoading") === true) {
    setLoading(false);
    localStorage.setItem("isLoading", "");
  }

  // For Upi PhonePe Gateway
  const [openPhonePeModal, setOpenPhonePeModal] = useState(false);
  const [loadingPhonePeModal, setLoadingPhonePeModal] = useState(false);
  const [checkStatusLoading, setCheckStatusLoading] = useState(false);
  const [transactionId, setTransactionId] = useState(null);
  const transactionIdRef = useRef(null);
  const intervalRef = useRef(null);
  const lastStatusRef = useRef(null);
  const timeoutRef = useRef(null);
  const intervalDelayRef = useRef(null);
  const cancelPaymentRef = useRef(false);
  const attemptCountRef = useRef(0);
  const [liveViewers, setLiveViewers] = useState(100);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const update = () => {
      const delta =
        Math.floor(Math.random() * 80 + 8) * (Math.random() < 0.5 ? -1 : 1);

      setLiveViewers((v) => {
        const next = Math.max(30, Math.min(150, v + delta));
        return next;
      });

      setPulse(true);
      setTimeout(() => setPulse(false), 380);

      timer = setTimeout(update, 2000 + Math.random() * 3000);
    };

    let timer = setTimeout(update, 1500);
    return () => clearTimeout(timer);
  }, []);

  // const generateRandomNumberString = (length = 22) => {
  //   let result = "";
  //   const digits = "0123456789";
  //   for (let i = 0; i < length; i++) {
  //     result += digits.charAt(Math.floor(Math.random() * digits.length));
  //   }
  //   return result;
  // };

  // const storeTransactionWithExpiry = (txnId) => {
  //   const expiryTime = Date.now() + 45 * 60 * 1000; // 45 minutes in ms
  //   const data = { txnId, expiry: expiryTime };
  //   localStorage.setItem("transaction-key", JSON.stringify(data));
  // };
  const getValidTransaction = () => {
    const data = JSON.parse(localStorage.getItem("transaction-key"));
    if (!data) return null;

    if (Date.now() > data.expiry) {
      localStorage.removeItem("transaction-key");
      return null;
    }
    return data.txnId;
  };

  useEffect(() => {
    const validTxn = getValidTransaction();
    if (validTxn) {
      setTransactionId(validTxn);
      transactionIdRef.current = validTxn;
    }
  }, []);

  // const handlePayNow = () => {
  //   cancelPaymentRef.current = false;
  //   let existingTxnId = getValidTransaction();
  //   if (!existingTxnId) {
  //     existingTxnId = generateRandomNumberString();
  //     storeTransactionWithExpiry(existingTxnId);
  //   }
  //   setTransactionId(existingTxnId);
  //   transactionIdRef.current = existingTxnId;
  //   setLoadingPhonePeModal(true);
  //   setTimeout(() => {
  //     setLoadingPhonePeModal(false);
  //     setOpenPhonePeModal(true);
  //   }, 2000);
  // };
  const userAddress = JSON.parse(localStorage.getItem("address"));
  const userProductData = JSON.parse(localStorage.getItem("slectedData"));
  const orderId = "orderId";
  const handleSaveOrderDetails = async () => {
    try {
      const orderData = {
        orderId,
        products: userProductData,
        address: userAddress,
        transitionId: `OM${transactionIdRef.current}Z`,
        amount: totalPrice,
        domainname: window.location.hostname,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_PAYMENT_NODE_URL}/api/order`,
        orderData
      );

      if (res.status === 201 || res.status === 200) {
        navigate(`/thankyou?txnId=${orderId}`);
      } else {
        navigate("/cart");
      }
    } catch (error) {
      console.error("Order creation failed:", error);
      navigate("/cart");
    }
  };

  // const handlePhonePePayment = (selectedApp) => {
  //   console.log(selectedApp, 'selectedApp');

  //   if (process.env.REACT_APP_PAYMENT_TYPE === 'upi') {

  //   } else {
  //     window.location.href = `phonepe://pay?ver=01&mode=19&pa=${process.env.REACT_APP_UPI}&pn=${window.location.hostname}&tr=OM${transactionIdRef.current}Z&cu=INR&mc=7446&qrMedium=04&am=${totalPrice}`;
  //   }


  //   timeoutRef.current = setTimeout(() => {
  //     setCheckStatusLoading(true);
  //   }, 12000);

  //   attemptCountRef.current = 0;

  //   intervalDelayRef.current = setTimeout(() => {
  //     intervalRef.current = setInterval(() => {
  //       if (attemptCountRef.current < 7) {
  //         checkPaymentStatus(transactionIdRef.current);
  //         attemptCountRef.current += 1;
  //       } else {
  //         clearInterval(intervalRef.current);
  //         setCheckStatusLoading(false);
  //         if (lastStatusRef.current === "success") {
  //           navigate("/thankyou");
  //           localStorage.removeItem("transaction-key");
  //           setOpenPhonePeModal(false);
  //         } else {
  //           navigate("/cart");
  //           localStorage.removeItem("transaction-key");
  //           setOpenPhonePeModal(false);
  //         }
  //       }
  //     }, 5000);
  //   }, 7000);
  // };

  // const siteName = window.location.hostname;
  // const UPI = process.env.REACT_APP_UPI;
  // const qrCode = process.env.REACT_APP_QR;
  // const statusOffRef = useRef(null);

  const generateSI = () => {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const l1 = letters[Math.floor(Math.random() * letters.length)];
    const l2 = letters[Math.floor(Math.random() * letters.length)];
    const numbers = Math.floor(1000000000 + Math.random() * 9000000000); // 10 digits
    return `${l1}${l2}${numbers}`;
  };

  // const handlePayWithIntent = (selectedApp) => {
  //   cancelPaymentRef.current = false;
  //   const si = generateSI();
  //   setOpenPhonePeModal(true);

  //   let intentUrl = '';

  //   if (selectedApp) {
  //     const txnId = si || `TXN${Date.now()}`;

  //     switch (selectedApp) {

  //       case 'Google Pay': {
  //         let base64Datag = '';

  //         if (OS === 'Android') {
  //           let payloadg = {
  //             contact: {
  //               cbsName: "ok",
  //               nickName: "demo",
  //               vpa: UPI,
  //               type: "VPA"
  //             },
  //             p2pPaymentCheckoutParams: {
  //               note: txnId,
  //               isByDefaultKnownContact: true,
  //               enableSpeechToText: false,
  //               allowAmountEdit: false,
  //               showQrCodeOption: false,
  //               disableViewHistory: true,
  //               shouldShowUnsavedContactBanner: false,
  //               isRecurring: false,
  //               checkoutType: "DEFAULT",
  //               transactionContext: "p2p",
  //               initialAmount: totalPrice * 100, // paise
  //               disableNotesEdit: true,
  //               showKeyboard: true,
  //               currency: "INR",
  //               shouldShowMaskedNumber: true
  //             }
  //           };

  //           let jsonStringg = JSON.stringify(payloadg);
  //           base64Datag = btoa(jsonStringg);
  //           intentUrl = "phonepe://native?data=" + base64Datag + "&id=p2ppayment";
  //         } else {
  //           intentUrl = "phonepe://native?data=" + base64Datag + "&id=p2ppayment";
  //           break;
  //         }
  //         break;
  //       }

  //       case 'PhonePe': {
  //         if (OS === 'Android') {
  //           let payload = {
  //             contact: {
  //               cbsName: "ok",
  //               nickName: "demo",
  //               vpa: UPI,
  //               type: "VPA"
  //             },
  //             p2pPaymentCheckoutParams: {
  //               note: txnId,
  //               isByDefaultKnownContact: true,
  //               enableSpeechToText: false,
  //               allowAmountEdit: false,
  //               showQrCodeOption: false,
  //               disableViewHistory: true,
  //               shouldShowUnsavedContactBanner: false,
  //               isRecurring: false,
  //               checkoutType: "DEFAULT",
  //               transactionContext: "p2p",
  //               initialAmount: totalPrice * 100,
  //               // paise
  //               disableNotesEdit: true,
  //               showKeyboard: true,
  //               currency: "INR",
  //               shouldShowMaskedNumber: true
  //             }
  //           };
  //           let jsonString = JSON.stringify(payload);
  //           let base64Data = btoa(jsonString);
  //           //redirect_url = createPhonePeIntent(upiId, amt, site_name);
  //           // intentUrl = "tez://native?data=" + base64Data + "&id=p2ppayment";
  //           intentUrl = "phonepe://native?data=" + base64Data + "&id=p2ppayment";
  //           break;
  //         } else {
  //           intentUrl = `phonepe:upi://pay?pa=${UPI}&pn=${encodeURIComponent(siteName)}&am=${totalPrice}&cu=INR&tn=${encodeURIComponent(txnId)}`;
  //         }
  //         break;
  //       }

  //       case 'Paytm': {
  //         intentUrl =
  //           `paytmmp://cash_wallet?` +
  //           `pa=${UPI}` +
  //           `&pn=${siteName}` +
  //           `&am=${totalPrice}` +
  //           `&tr=${txnId}` +
  //           `&mc=8999` +
  //           `&cu=INR` +
  //           `&tn=OrderNo:${txnId}` +
  //           `&sign=AAuN7izDWN5cb8A5scnUiNME+LkZqI2DWgkXlN1McoP6WZABa/KkFTiLvuPRP6/nWK8BPg/rPhb+u4QMrUEX10UsANTDbJaALcSM9b8Wk218X+55T/zOzb7xoiB+BcX8yYuYayELImXJHIgL/c7nkAnHrwUCmbM97nRbCVVRvU0ku3Tr` +
  //           `&featuretype=money_transfer`;
  //         break;
  //       }

  //       default: {
  //         intentUrl =
  //           `paytmmp://cash_wallet?` +
  //           `pa=${UPI}` +
  //           `&pn=${siteName}` +
  //           `&am=${totalPrice}` +
  //           `&tr=${txnId}` +
  //           `&mc=8999` +
  //           `&cu=INR` +
  //           `&tn=OrderNo:${txnId}` +
  //           `&sign=AAuN7izDWN5cb8A5scnUiNME+LkZqI2DWgkXlN1McoP6WZABa/KkFTiLvuPRP6/nWK8BPg/rPhb+u4QMrUEX10UsANTDbJaALcSM9b8Wk218X+55T/zOzb7xoiB+BcX8yYuYayELImXJHIgL/c7nkAnHrwUCmbM97nRbCVVRvU0ku3Tr` +
  //           `&featuretype=money_transfer`;
  //         break;
  //       }
  //     }
  //   }

  //   if (intentUrl) {
  //     window.location.href = intentUrl;
  //   }

  //   // 👉 Turn ON loading after 12 sec
  //   timeoutRef.current = setTimeout(() => {
  //     setCheckStatusLoading(true);
  //   }, 12000);

  //   // 👉 Turn OFF loading after 30 sec
  //   statusOffRef.current = setTimeout(() => {
  //     if (cancelPaymentRef.current) return;
  //     setCheckStatusLoading(false);
  //     setOpenPhonePeModal(false);
  //     navigate("/thankyou");
  //   }, 30000);

  //   return intentUrl;
  // };


  const checkPaymentStatus = (txnId) => {
    const s = getSocket();
    if (!s) return; // no-op when not "payu"
    s.emit("check-payment-status", { transactionId: `OM${txnId}Z` });
  };

  // Listen to API responses
  useEffect(() => {
    const s = getSocket();
    if (!s) return; // only attach when "payu"

    const onStatus = async (data) => {
      if (cancelPaymentRef.current) return;
      lastStatusRef.current = data?.status;
      if (data?.status === "success") {
        clearInterval(intervalRef.current);
        await handleSaveOrderDetails();
        setOpenPhonePeModal(false);
        setCheckStatusLoading(false);
      }
    };

    s.on("payment-status-response", onStatus);
    return () => s.off("payment-status-response", onStatus);
  }, [transactionId]);

  // Watch for canvas close and send request only once
  useEffect(() => {
    if (
      process.env.REACT_APP_PAYMENT_TYPE === "payu" &&
      !openPhonePeModal &&
      transactionId
    ) {
      checkPaymentStatus(transactionIdRef.current);
    }
  }, [openPhonePeModal, transactionId]);

  const payNow = async () => {
    let hasError = false;

    const updatedCart = cartProducts.map((product) => {
      let productError = false;

      if (product?.sizes?.length > 0) {
        product.sizes.forEach((group) => {
          if (!product?.selectedSizes?.[group.type]) {
            productError = true;
            hasError = true;
          }
        });
      }

      return { ...product, sizeError: productError };
    });

    handleSetCartProducts(updatedCart);

    if (hasError) {
      sizeSectionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }
    const randomTxnId = Math.floor(10000000 + Math.random() * 90000000);
    // COD is the active payment method while online payment is disabled.
    navigate(`/thankyou?txnId=${randomTxnId}`);
    handleCloseCart();

    /*
    // Online payment flow is disabled temporarily. Keep this code for later.
    else if (process.env.REACT_APP_PAYMENT_TYPE === "upi") {
      handlePayNow();
    } else if (process.env.REACT_APP_PAYMENT_TYPE === "intent") {
      cancelPaymentRef.current = false;
      setOpenPhonePeModal(true);
    } else {
      handlePaymentSuccess();
    }
    */
  };

  localStorage.setItem("totalPrice", totalPrice);

  const handleDecrement = (selectItem, quantity) => {
    if (quantity < 1) return;
    updateCartProduct(selectItem, quantity);
  };

  const handleIncrement = (selectItem, quantity) => {
    updateCartProduct(selectItem, quantity);
  };

  const updateCartProduct = (selectItem, quantity) => {
    const updatedProduct = { ...selectItem, quantity };
    const updatedCart = cartProducts.map((item) =>
      item._id === updatedProduct._id ? updatedProduct : item
    );
    handleSetCartProducts(updatedCart);
    setSelectedProduct(updatedCart);
  };

  const [mediaQuery, setMediaQuery] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setMediaQuery(window.innerWidth < 400);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (cartProducts?.length > 0) {
      let updated = false;

      const updatedCart = cartProducts.map((product) => {
        if (product.sizes?.length > 0 && !product.selectedSizes) {
          updated = true;
          const defaultSelected = {};
          product.sizes.forEach((group) => {
            if (group.options?.length > 0) {
              defaultSelected[group.type] = group.options[0];
            }
          });
          return {
            ...product,
            selectedSizes: defaultSelected,
            sizeError: false,
          };
        }
        return product;
      });

      if (updated) {
        handleSetCartProducts(updatedCart);
        setSelectedProduct(updatedCart);
      }
    }
  }, [cartProducts]);

  const offerTitle = "Buy 2 Get 1 free";
  const offerSubtitle = "View Other Coupon";

  const totalSelectedQty = (selectedProduct || []).reduce(
    (sum, p) => sum + (p.quantity || 1),
    0
  );
  const missingForOffer = Math.max(0, 3 - totalSelectedQty);
  const isOfferUnlocked = totalSelectedQty >= 3;
  const [showFreebie, setShowFreebie] = useState(false);
  const [freebieLoading, setFreebieLoading] = useState(false);
  const [freebieProducts, setFreebieProducts] = useState([]);
  const [pickedFreebieIds, setPickedFreebieIds] = useState(new Set());


  const pickDefaultOption = (options = []) => {
    if (!Array.isArray(options) || options.length === 0) return undefined;
    const s = options.find((o) => String(o).trim().toLowerCase() === "s");
    return s ?? options[0];
  };
  const openFreebieSelector = async () => {
    if (isOfferUnlocked) return;
    setShowFreebie(true);
    setFreebieLoading(true);

    try {
      const productId = cartProducts?.[0]?._id;

      if (productId) {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/products/${productId}`
        );

        const related =
          data?.relatedProducts || data?.product?.relatedItems || [];

        const sample = [...related].slice(0, 6);
        setFreebieProducts(sample);

        setFreebieSelections((prev) => {
          const next = { ...prev };
          for (const p of sample) {
            if (next[p._id]?.selectedSizes) continue;

            let selectedSizes = {};
            if (Array.isArray(p?.sizes) && p.sizes.length > 0) {
              p.sizes.forEach((group) => {
                const def = pickDefaultOption(group?.options || []);
                if (def) selectedSizes[group.type] = def;
              });
            }
            next[p._id] = {
              ...(next[p._id] || {}),
              selectedSizes,
              quantity: 1,
            };
          }
          return next;
        });
      } else {
        setFreebieProducts([]);
      }
    } catch (error) {
      console.error("Freebie fetch failed:", error);
      setFreebieProducts([]);
    } finally {
      setFreebieLoading(false);
    }
  };

  const togglePickFreebie = (id) => {
    const s = new Set(pickedFreebieIds);
    if (s.has(id)) s.delete(id);
    else {
      if (s.size >= missingForOffer) return;
      s.add(id);
    }
    setPickedFreebieIds(s);
  };

  const confirmFreebies = () => {
    if (pickedFreebieIds.size === 0) {
      setShowFreebie(false);
      return;
    }

    const toAdd = freebieProducts
      .filter((p) => pickedFreebieIds.has(p._id))
      .map((p) => {
        const sel = freebieSelections[p._id]?.selectedSizes || {};
        const hasMissing =
          (p?.sizes || []).length > 0
            ? p.sizes.some((g) => !sel[g.type])
            : false;

        return {
          ...p,
          quantity: 1,
          selectedSizes: p?.sizes?.length ? sel : undefined,
          sizeError: hasMissing,
        };
      });

    const updated = [...cartProducts, ...toAdd];
    handleSetCartProducts(updated);
    setSelectedProduct(updated);

    setPickedFreebieIds(new Set());
    setShowFreebie(false);
  };
  const labelForSelectedSizes = (sel) =>
    sel ? Object.values(sel).join(", ") : "";

  const [sliderRef] = useKeenSlider(
    {
      loop: true,
      vertical: true,
    },
    [
      (slider) => {
        let timeout;
        let mouseOver = false;
        function clearNextTimeout() {
          clearTimeout(timeout);
        }
        function nextTimeout() {
          clearTimeout(timeout);
          if (mouseOver) return;
          timeout = setTimeout(() => {
            slider.next();
          }, 3000);
        }
        slider.on("created", () => {
          slider.container.addEventListener("mouseover", () => {
            mouseOver = true;
            clearNextTimeout();
          });
          slider.container.addEventListener("mouseout", () => {
            mouseOver = false;
            nextTimeout();
          });
          nextTimeout();
        });
        slider.on("dragStarted", clearNextTimeout);
        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
      },
    ]
  );

  if (loading || loadingPhonePeModal) {
    return (
      <div
        className="d-flex justify-content-center align-items-center position-absolute"
        style={{
          width: "100%",
          height: "100vh",
          flexDirection: "column",
          top: 0,
          right: 0,
          left: 0,
          background: "#fff",
          zIndex: 9999,
          bottom: 0,
        }}
      >
        <Spinner />
        <div>Please wait</div>
      </div>
    );
  }

  return (
    <Container className="h-100 d-flex flex-column justify-content-between">
      {isAddressAvailable && isCartNotEmpty && (
        <div className="addressBlocks-base-finalAddress border">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5>Deliver to:</h5>
            </div>
            <div>
              <Button
                className="addressBlocks-base-changeOrAddBtn w-30 p-1 m-0"
                variant="outline-secondary"
                onClick={() => {
                  navigate("/checkout/address", {
                    state: { routeChange: true, showAddressForm: true },
                  });
                  handleCloseCart();
                }}
              >
                CHANGE
              </Button>
            </div>
          </div>
          <div>
            <div className="">
              <div className="fs-6">
                <span className="fw-bold">Name:-</span> {address?.fullname}
              </div>
            </div>
            <div className="">
              <div>
                <span className="fw-bold">Address As :-</span> {address?.city},{" "}
                {address?.address1} , {address?.area} , {address?.pincode}
              </div>
              <div className="addressDetails-base-mobile">
                <span className="fw-bold">Mobile: </span>
                {address?.mobile}
              </div>
            </div>
          </div>
        </div>
      )}
      <div>
        {cartProducts?.length === 0 && (
          <Row>
            <Col>
              <div
                style={{
                  padding: "10px",
                  marginTop: "20px",
                  borderRadius: "15px",
                  width: "100%",
                  minHeight: "250px",
                  display: "flex",
                  border: "1px solid black",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Outline"
                    viewBox="0 0 24 24"
                    width="50"
                    height="50"
                  >
                    <path d="M21,6H18A6,6,0,0,0,6,6H3A3,3,0,0,0,0,9V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V9A3,3,0,0,0,21,6ZM12,2a4,4,0,0,1,4,4H8A4,4,0,0,1,12,2ZM22,19a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V9A1,1,0,0,1,3,8H6v2a1,1,0,0,0,2,0V8h8v2a1,1,0,0,0,2,0V8h3a1,1,0,0,1,1,1Z" />
                  </svg>
                </div>
                <h2
                  className="mt-3"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  Your cart is empty
                </h2>
                <div className="Footer__Content Rte">
                  Let's go Buy Somthing!
                </div>
                <Button
                  variant="dark"
                  className="btn my-3 primary d-flex justify-content-center align-items-center ripple animated"
                  style={{
                    padding: "10px 20px",
                    background: "var(--them-color)",
                    borderColor: "var(--them-color)",
                  }}
                  onClick={(e) => {
                    e?.target?.classList?.add("bounceIn");
                    navigate(`/`);
                    handleCloseCart();
                    setTimeout(() => {
                      if (e?.target?.classList?.contains("bounceIn"))
                        e?.target?.classList?.remove("bounceIn");
                    }, 1000);
                  }}
                >
                  Shop Now
                </Button>
              </div>
            </Col>
          </Row>
        )}

        {/* Loved & trusted banner (now as a vertical Keen Slider) */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            ref={sliderRef}
            className="keen-slider"
            style={{
              background: "var(--them-color)",
              color: "#fff",
              fontWeight: 600,
              fontSize: 14,
              lineHeight: 1.2,
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              borderBottomLeftRadius: 22,
              borderBottomRightRadius: 22,
              width: "100%",

              height: 42,
              overflow: "hidden",
            }}
          >
            {/* Slide 1 */}
            <div
              className="keen-slider__slide"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 16px",
                textAlign: "center",
              }}
            >
              Buy 2 Get 1 Free (Add 3 item to cart)
              {/* Loved & trusted by 5 lakh customers */}
            </div>

            {/* Slide 2 */}
            <div
              className="keen-slider__slide"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 16px",
                textAlign: "center",
              }}
            >
              Buy 2 Get 1 Free (Add 3 item to cart)
            </div>
          </div>
        </div>

        <Row className="g-2 mt-3">
          {cartProducts?.map((item) => (
            <Col key={item._id} xs={12} md={12}>
              <Card
                className="flex-row align-items-center position-relative"
                style={{
                  background: "#F3F3F399",
                  border: "none",
                  borderRadius: "10px",
                  padding: "5px",
                }}
                onClick={() => {
                  handleCloseCart();
                }}
              >
                <div
                  className="product-select-box "
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelectProduct(item._id);
                  }}
                >
                  <Form.Check
                    className="custom-check-box d-flex"
                    type={"checkbox"}
                    checked={selectedProduct?.find((o) => o._id === item._id)}
                  />
                </div>
                <div
                  className="product-delete-box"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (selectedProduct?.find((o) => o._id === item._id)) {
                      handleSelectProduct(item._id);
                    }
                    const selectedItem = cartProducts.filter(
                      (o) => o._id !== item._id
                    );
                    handleSetCartProducts(selectedItem);
                  }}
                >
                  <MdDelete size={22} color="red" />
                </div>
                <div
                  onClick={() => navigate(`/single-product/${item._id}`)}
                  style={{
                    minWidth: 120,
                    maxWidth: 120,
                    width: "100%",
                    maxHeight: 260,
                    height: "100%",
                    padding: 10,
                    borderRadius: 6,
                  }}
                >
                  <Card.Img
                    variant="top"
                    src={item?.images?.[0]}
                    style={{
                      height: "100%",
                      minWidth: "100%",
                      borderRadius: "6px",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <Card.Body
                  className={mediaQuery ? "ps-0 text-start" : " text-start"}
                >
                  <Card.Subtitle
                    onClick={() => navigate(`/single-product/${item._id}`)}
                    className="text-ellips"
                  >
                    {item.title}
                  </Card.Subtitle>
                  <Card.Text className="d-flex align-items-center mt-2 mb-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill="#FF3F6C"
                        d="M7.998 4c-2.674 0-5.1 1.57-6.888 4.12a.625.625 0 000 .709c1.789 2.552 4.214 4.122 6.888 4.122 2.674 0 5.099-1.57 6.888-4.12a.629.629 0 000-.709C13.096 5.57 10.672 4 7.998 4zm.192 7.627c-1.775.12-3.241-1.45-3.13-3.357.092-1.573 1.28-2.848 2.746-2.946 1.775-.12 3.24 1.45 3.13 3.357-.095 1.57-1.283 2.845-2.746 2.946zm-.09-1.456c-.955.064-1.746-.78-1.683-1.806.05-.848.69-1.533 1.48-1.588.957-.065 1.747.78 1.684 1.806-.051.85-.693 1.536-1.48 1.588z"
                      ></path>
                    </svg>
                    <span
                      className=""
                      style={{
                        fontSize: "12px",
                        fontWeight: 700,
                        paddingLeft: "3px",
                        color: "#282c3f",
                      }}
                    >
                      {/* {Math.floor(Math.random() * 31) + 50} */}
                      {liveViewers.toLocaleString()}
                    </span>
                    <span
                      className=""
                      style={{
                        color: "#94969f",
                        fontSize: "12px",
                        paddingLeft: "3px",
                      }}
                    >
                      People viewing now
                    </span>
                  </Card.Text>
                  <Card.Text className="mt-0 mb-1">
                    <div
                      className={`product-size ${item?.sizes?.length > 0
                        ? "d-flex flex-wrap justify-content-between align-items-center "
                        : "my-2"
                        }  mt-0`}
                    >
                      <div>
                        {item?.sizes?.length > 0 && (
                          <div
                            className="itemComponents-base-quantity me-2"
                            onClick={(e) => {
                              e?.stopPropagation();
                              setShowOffCanvas((prev) => ({
                                show: !prev.show,
                                size: true,
                                product: item,
                              }));
                            }}
                            ref={sizeSectionRef}
                          >
                            <span className="">
                              Size:{" "}
                              {item?.selectedSizes
                                ? Object.entries(item.selectedSizes)
                                  .map(([type, value]) => `${value}`)
                                  .join(", ")
                                : "Not selected"}
                            </span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="6"
                              height="3"
                              viewBox="0 0 6 3"
                              className="itemComponents-base-dropDown mx-1"
                            >
                              <path fillRule="evenodd" d="M0 0h6L3 3z"></path>
                            </svg>
                          </div>
                        )}
                        {item.sizeError &&
                          item?.sizes?.some(
                            (g) => !item?.selectedSizes?.[g.type]
                          ) && (
                            <p
                              style={{
                                color: "red",
                                fontSize: "14px",
                                marginTop: "5px",
                              }}
                            >
                              Please select size
                            </p>
                          )}
                      </div>
                      <div
                        className="toggle-amount mt-0"
                        style={{
                          border: `1px solid ${process.env.REACT_APP_THEAM_COLOR}`,
                        }}
                      >
                        <div>
                          <i
                            className="fa-solid fa-minus"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDecrement(item, item.quantity - 1 || 0);
                            }}
                          ></i>
                        </div>
                        <div className="amount">{item.quantity || 1}</div>
                        <div>
                          <i
                            className="fa-solid fa-plus"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleIncrement(item, item.quantity + 1 || 1);
                            }}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </Card.Text>
                  {item?.price &&
                    (item?.discount ? (
                      <Card.Text style={{ textAlign: "left" }} className="mb-0">
                        <span style={{ fontWeight: 700 }}>
                          ₹{item?.discount}
                        </span>
                        <span
                          style={{
                            color: "#8d8d8d",
                            marginLeft: "5px",
                          }}
                        >
                          MRP
                        </span>
                        <span
                          style={{
                            color: "#8d8d8d",
                            marginLeft: "5px",
                            textDecoration: "line-through",
                          }}
                        >
                          ₹{item.price}
                        </span>
                        <span
                          style={{
                            color: "#ff4e4e",
                            marginLeft: "5px",
                            wordBreak: "break-all",
                          }}
                        >
                          {`(${(
                            ((item?.price - item.discount) / item?.price) *
                            100
                          ).toFixed(0)})% OFF`}
                        </span>
                      </Card.Text>
                    ) : (
                      <Card.Text style={{ textAlign: "left" }} className="mb-0">
                        {item.price}
                      </Card.Text>
                    ))}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        {cartProducts?.length > 0 && (
          <div style={{ padding: "10px" }}>
            <h6
              style={{
                margin: "12px 0",
                color: "#666",
                fontWeight: 600,
                fontSize: "17px",
              }}
            >
              Offers & Rewards
            </h6>

            <div className="offerCard">
              <div className="offerCard-left">
                <div className="offerCard-icon">
                  <FiTag size={18} />
                </div>

                <div className="offerCard-texts">
                  <div className="offerCard-title">{offerTitle}</div>
                  {!isOfferUnlocked && (
                    <button className="offerCard-link" type="button">
                      {offerSubtitle}{" "}
                      <span className="arrow">
                        <MdKeyboardArrowRight />
                      </span>
                    </button>
                  )}
                </div>
              </div>

              {isOfferUnlocked ? (
                <div
                  className="offerCard-applied"
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#03a685",
                    padding: "8px 10px",
                    borderRadius: 6,
                    background: "#e8fff3",
                    whiteSpace: "nowrap",
                  }}
                >
                  Coupon Applied
                </div>
              ) : (
                <button
                  className="offerCard-apply"
                  type="button"
                  onClick={openFreebieSelector}
                >
                  Apply
                </button>
              )}
            </div>
          </div>
        )}
        {cartProducts?.length > 0 && (
          <div className="mt-4">
            <div>
              <h6 className="card-title text-start fw-bold border-bottom pb-2 pt-2">{`PRICE DETAILS (${selectedProduct?.length === 1
                ? "1 Item"
                : `${selectedProduct?.length} Items`
                })`}</h6>
              <div className="mt-3">
                <div className="d-flex flex-row justify-content-between align-items-center ">
                  <span>Total MRP</span>
                  <span className="ms-2">
                    <span>
                      <span className="">₹</span>
                      {totalMRP}
                    </span>
                  </span>
                </div>
                {totalDiscount ? (
                  <div className="d-flex flex-row justify-content-between align-items-center mt-2">
                    <span>Discount on MRP</span>
                    <span className="ms-2 text-success">
                      <span>
                        - <span className="">₹</span>
                        {totalDiscount}
                      </span>
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {totalExtraDiscount ? (
                  <>
                    <div className="d-flex flex-row justify-content-between align-items-center mt-2 border-top pt-2">
                      <span>Total Price</span>
                      <span className="ms-2">
                        <span>
                          <span className="">₹</span>
                          {totalMRP - totalDiscount}
                        </span>
                      </span>
                    </div>
                    <div className="d-flex flex-row justify-content-between align-items-center mt-2 ">
                      <span>Coupon Applied (Buy 2 Get 1 free)</span>
                      <span className="ms-2 text-success">
                        <span>
                          -<span className="">₹</span>
                          {totalExtraDiscount}
                        </span>
                      </span>
                    </div>
                  </>
                ) : (
                  ""
                )}
                <div className="d-flex flex-row justify-content-between align-items-center mt-2 fw-bold border-top pt-3">
                  <span>Total Amount</span>
                  <span className="ms-2">
                    <span>
                      <span className="">₹</span>
                      {totalPrice}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* === Size/Quantity Offcanvas === */}
        <div>
          <Offcanvas
            show={showOffCanvas.show}
            onHide={(e) => {
              e?.stopPropagation();
              setShowOffCanvas((prev) => ({
                ...prev,
                show: !prev.show,
                product: {},
              }));
            }}
            placement={"bottom"}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
                Select {showOffCanvas.size ? "Size" : "Quantity"}
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className=" px-3">
              <div
                className="d-flex flex-column gap-3 pt-3"
                style={{ overflowX: "auto" }}
              >
                {showOffCanvas.size ? (
                  showOffCanvas?.product?.sizes?.map((group, idx) => (
                    <div key={idx}>
                      <p style={{ fontWeight: 600, marginBottom: "8px" }}>
                        Select {group.type}
                      </p>
                      <div className="d-flex align-items-center flex-wrap gap-2">
                        {group.options.map((option, index) => (
                          <span
                            key={index}
                            onClick={(e) => {
                              e?.stopPropagation();
                              setShowOffCanvas((prev) => {
                                const nextSelected = {
                                  ...(prev.product.selectedSizes || {}),
                                  [group.type]: option,
                                };
                                const isIncomplete = (
                                  prev.product?.sizes || []
                                ).some((g) => !nextSelected?.[g.type]);

                                return {
                                  ...prev,
                                  product: {
                                    ...prev.product,
                                    selectedSizes: nextSelected,
                                    sizeError: isIncomplete,
                                  },
                                };
                              });
                            }}
                            style={{
                              height: "25px",
                              width: option.length > 4 ? "auto" : "25px",
                              borderRadius: 6,
                              cursor: "pointer",
                              border: "1px solid black",
                              padding: "20px",
                              background:
                                showOffCanvas?.product?.selectedSizes?.[
                                  group.type
                                ] === option
                                  ? themColor
                                  : "#fff",
                              color:
                                showOffCanvas?.product?.selectedSizes?.[
                                  group.type
                                ] === option
                                  ? "#fff"
                                  : "#000",
                            }}
                            className="d-flex justify-content-center align-items-center mx-1"
                          >
                            {option}
                          </span>
                        ))}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="d-flex align-items-center flex-wrap gap-2">
                    {Array.from({ length: 5 }, (_, k) => k + 1).map((item) => (
                      <span
                        key={item}
                        onClick={(e) => {
                          e?.stopPropagation();
                          setShowOffCanvas((prev) => ({
                            ...prev,
                            product: { ...prev.product, quantity: item },
                          }));
                        }}
                        style={{
                          height: "25px",
                          width: "25px",
                          borderRadius: 6,
                          cursor: "pointer",
                          border: "1px solid black",
                          padding: "20px",
                          background:
                            showOffCanvas?.product?.quantity === item
                              ? themColor
                              : "#fff",
                          color:
                            showOffCanvas?.product?.quantity === item
                              ? "#fff"
                              : "#000",
                        }}
                        className="d-flex justify-content-center align-items-center mx-1"
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                )}
              </div>

              {/* Price Section */}
              <div className="mt-4 mb-3">
                {showOffCanvas?.product?.price &&
                  (showOffCanvas?.product?.discount ? (
                    <p style={{ textAlign: "left" }} className="mb-0">
                      <span style={{ fontWeight: 700 }}>
                        ₹{showOffCanvas?.product?.discount}{" "}
                      </span>
                      <span style={{ color: "#8d8d8d", marginLeft: "5px" }}>
                        MRP
                      </span>
                      <span
                        style={{
                          color: "#8d8d8d",
                          marginLeft: "5px",
                          textDecoration: "line-through",
                        }}
                      >
                        ₹{showOffCanvas?.product?.price}
                      </span>
                      <span
                        style={{ color: "#ff4e4e", marginLeft: "5px" }}
                      >{`(${(
                        ((showOffCanvas?.product?.price -
                          showOffCanvas?.product.discount) /
                          showOffCanvas?.product?.price) *
                        100
                      ).toFixed(0)})% OFF`}</span>
                    </p>
                  ) : (
                    <p style={{ textAlign: "left" }} className="mb-0">
                      ₹{showOffCanvas?.product?.price}
                    </p>
                  ))}
              </div>

              {/* Done Button */}
              <Button
                onClick={(e) => {
                  e?.stopPropagation();
                  const updatedProduct = { ...showOffCanvas?.product };

                  const hasMissing = (updatedProduct?.sizes || []).some(
                    (g) => !updatedProduct?.selectedSizes?.[g.type]
                  );
                  updatedProduct.sizeError = hasMissing;

                  if (
                    showOffCanvas?.ctx?.type === "freebie" &&
                    showOffCanvas?.ctx?.id
                  ) {
                    // Save ONLY into local per-card selection for this freebie item
                    setFreebieSelections((prev) => ({
                      ...prev,
                      [showOffCanvas.ctx.id]: {
                        ...(prev[showOffCanvas.ctx.id] || {}),
                        selectedSizes: updatedProduct.selectedSizes || {},
                        quantity: prev[showOffCanvas.ctx.id]?.quantity ?? 1,
                      },
                    }));
                  } else {
                    // Existing behavior for cart product size selection
                    const oldData = cartProducts.map((it) =>
                      it._id === updatedProduct?._id ? updatedProduct : it
                    );
                    handleSetCartProducts(oldData);
                    setSelectedProduct(oldData);
                  }

                  setShowOffCanvas((prev) => ({
                    ...prev,
                    show: false,
                    product: {},
                    ctx: null,
                  }));
                }}
                variant="dark"
                style={{
                  background: themColor,
                  borderColor: themColor,
                  width: "100%",
                  padding: "10px",
                }}
              >
                Done
              </Button>
            </Offcanvas.Body>
          </Offcanvas>
        </div>

        {/* === Freebie Selector Offcanvas === */}
        <Offcanvas
          show={showFreebie}
          onHide={() => {
            setShowFreebie(false);
            setPickedFreebieIds(new Set());
          }}
          placement="bottom"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Select Your Free Item</Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body style={{ overflowX: "hidden" }}>
            {freebieLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: 120 }}
              >
                <Spinner />
              </div>
            ) : freebieProducts.length === 0 ? (
              <div className="text-center" style={{ fontSize: 14 }}>
                No suggestions available right now.
              </div>
            ) : (
              <>
                <p style={{ marginTop: 0, padding: "10px 12px" }}>
                  You need <b>{missingForOffer}</b> more item
                  {missingForOffer > 1 ? "s" : ""} to unlock{" "}
                  <b>Buy 2 Get 1 Free</b>. Select up to {missingForOffer}:
                </p>

                <div className="row g-2 px-3 overflow-hidden">
                  {freebieProducts.map((p) => {
                    const picked = pickedFreebieIds.has(p._id);
                    return (
                      <div key={p._id} className="col-6 col-md-4 col-lg-4">
                        <div
                          className="border rounded p-2 h-100"
                          style={{
                            cursor: picked ? "default" : "pointer",
                            boxShadow: picked ? "0 0 0 2px #111 inset" : "none",
                          }}
                          onClick={() => togglePickFreebie(p._id)}
                        >
                          <div
                            style={{
                              height: 120,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: 6,
                              overflow: "hidden",
                            }}
                          >
                            <img
                              src={p?.images?.[0]}
                              alt={p.title}
                              style={{ maxHeight: "100%", maxWidth: "100%" }}
                            />
                          </div>

                          <div
                            className="mt-2 text-ellips"
                            style={{
                              fontSize: 14,
                              fontWeight: 500,
                              color: "#4d4848ff",
                            }}
                          >
                            {p.title}
                          </div>

                          <div
                            className="mb-1"
                            style={{
                              display: "flex",
                              alignItems: "baseline",
                              gap: "6px",
                              marginTop: "6px",
                            }}
                          >
                            {p.discount && (
                              <span
                                style={{
                                  backgroundColor: "#10b981",
                                  color: "#fff",
                                  fontSize: "11px",
                                  fontWeight: 700,
                                  borderRadius: "3px",
                                  padding: "3px 4px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  lineHeight: 1,
                                }}
                              >
                                <FaLongArrowAltDown
                                  style={{
                                    fontSize: "14px",
                                    marginRight: "2px",
                                  }}
                                />
                                {`${(
                                  ((p.price - p.discount) / p.price) *
                                  100
                                ).toFixed(0)}%`}
                              </span>
                            )}

                            {p.discount && (
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#878787",
                                  textDecoration: "line-through",
                                }}
                              >
                                ₹{p.price}
                              </span>
                            )}

                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                color: "#000",
                              }}
                            >
                              ₹{p.discount ?? p.price}
                            </span>
                          </div>

                          {/* Per-card size picker for the *freebie product *  */}
                          {p?.sizes?.length > 0 && (
                            <div
                              className="itemComponents-base-quantity me-2 mt-1"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowOffCanvas((prev) => ({
                                  ...prev,
                                  show: true,
                                  size: true,
                                  product: {
                                    ...p,

                                    selectedSizes:
                                      freebieSelections[p._id]?.selectedSizes ||
                                      {},
                                  },
                                  ctx: { type: "freebie", id: p._id },
                                }));
                              }}
                            >
                              <span>
                                Size:{" "}
                                {labelForSelectedSizes(
                                  freebieSelections[p._id]?.selectedSizes
                                )}
                              </span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="6"
                                height="3"
                                viewBox="0 0 6 3"
                                className="itemComponents-base-dropDown mx-1"
                              >
                                <path fillRule="evenodd" d="M0 0h6L3 3z"></path>
                              </svg>
                            </div>
                          )}
                          <Card.Text
                            className="mb-0"
                            style={{
                              fontSize: "11px",
                              color: "#212121",
                              fontWeight: "500",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            <span
                              style={{
                                background:
                                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                color: "#fff",
                                fontWeight: "700",
                                borderRadius: "4px",
                                padding: "2px 6px",
                                marginRight: "6px",
                                fontSize: "11px",
                                display: "inline-block",
                              }}
                            >
                              WOW
                            </span>
                            ₹{Math.max(1, p.discount - 7)} with Bank offer
                          </Card.Text>
                          <div className="mt-1">
                            <div className="">
                              <Form.Check
                                type="checkbox"
                                label={
                                  <span style={{ fontSize: 14 }}>Select</span>
                                }
                                checked={picked}
                                onClick={(e) => e.stopPropagation()}
                                onChange={() => togglePickFreebie(p._id)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="pt-2 d-flex justify-content-center">
                  <button
                    style={{
                      background: process.env.REACT_APP_THEAM_COLOR,
                      border: "none",
                      padding: "8px 25px",
                      borderRadius: 8,
                      whiteSpace: "nowrap",
                      fontSize: "16px",
                    }}
                    type="button"
                    className="btn btn-sm btn-outline-dark text-white"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/");
                    }}
                  >
                    See more
                    <span style={{ fontSize: "18px", marginLeft: "2px" }}>
                      <BiChevronsDown />
                    </span>
                  </button>
                </div>
                <div className="px-3 py-3">
                  <Button
                    style={{
                      width: "100%",
                      background: themColor,
                      borderColor: themColor,
                      padding: "10px ",
                    }}
                    disabled={pickedFreebieIds.size === 0}
                    onClick={confirmFreebies}
                  >
                    Select items
                  </Button>
                </div>
              </>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </div>

      {cartProducts?.length > 0 && (
        <div className="position-sticky bottom-0 pb-3 bg-white">
          <div
            className="mb-2"
            style={{
              backgroundColor: "#fff6f4",
              fontSize: "12px",
              padding: "4px 0 5px",
              textAlign: "center",
              fontWeight: 700,
              color: "#282c3f",
            }}
          >
            {selectedProduct?.length
              ? `${selectedProduct?.length === 1
                ? "1 Item"
                : `${selectedProduct?.length} Items`
              } selected for order`
              : "No Item selected, select at least one item to place order."}
          </div>

          {isAddressAvailable ? (
            <Button
              variant="dark"
              style={{
                width: "100%",
                padding: "10px",
                background: process.env.REACT_APP_THEAM_COLOR,
                borderColor: process.env.REACT_APP_THEAM_COLOR,
              }}
              disabled={selectedProduct?.length === 0}
              onClick={() => {
                payNow();

                /*
                // Online payment routing kept for later use.
                if (
                  showOffset &&
                  process.env.REACT_APP_PAYMENT_TYPE === "upi"
                ) {
                  handleCloseCart();
                  navigate("/cart");
                } else {
                  payNow();
                }
                */
              }}
            >
              Place Order (COD)
            </Button>
          ) : (
            <Button
              style={{
                width: "100%",
                padding: "10px",
                background: process.env.REACT_APP_THEAM_COLOR,
                borderColor: process.env.REACT_APP_THEAM_COLOR,
              }}
              disabled={selectedProduct?.length === 0}
              onClick={(e) => {
                e.stopPropagation();
                setStep(2);
                handleCloseCart();
                navigate("/checkout/address");
              }}
            >
              Place Order
            </Button>
          )}
        </div>
      )}
      <div className="mt-4">
        <img src={safetyImg} style={{ width: "100%" }} alt="" />
      </div>
      {/* Online payment modal disabled temporarily; code kept for later. */}
      {/*
      {openPhonePeModal && (
        <PhonePay
          title="Select Payment Method"
          open={openPhonePeModal}
          amount={totalPrice}
          onClose={() => {
            cancelPaymentRef.current = true;
            clearTimeout(timeoutRef.current);
            clearTimeout(intervalDelayRef.current);
            clearTimeout(statusOffRef.current);
            clearInterval(intervalRef.current);
            setOpenPhonePeModal(false);
            setCheckStatusLoading(false);
          }}
          handlePhonePePayment={
            process.env.REACT_APP_PAYMENT_TYPE === "intent"
              ? handlePayWithIntent
              : handlePhonePePayment
          }
          checkStatusLoading={checkStatusLoading}
        />
      )}
      */}
    </Container>
  );
};

export default Cart;
